import Cookies from 'js-cookie'

const TokenKey = 'Token-Key'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

const LoginNameKey = "LoginName-Key";

export function getLoginName() {
  return Cookies.get(LoginNameKey)
}

export function setLoginName(loginName) {
  return Cookies.set(LoginNameKey, loginName)
}

export function removeLoginName() {
  return Cookies.remove(LoginNameKey)
}

const LoginPwdKey = "LoginPwd-Key";

export function getLoginPwd() {
  return Cookies.get(LoginPwdKey)
}

export function setLoginPwd(loginPwd) {
  return Cookies.set(LoginPwdKey, loginPwd)
}

export function removeLoginPwd() {
  return Cookies.remove(LoginPwdKey)
}
const LogincompanyidKey = "Logincompanyid-Key";
export function setLoginCompanyid(loginCompanyid) {
  return Cookies.set(LogincompanyidKey, loginCompanyid)
}

export function removeLoginCompanyid() {
  return Cookies.remove(LogincompanyidKey)
}
export function getLoginCompanyid() {
  return Cookies.get(LogincompanyidKey)
}
const Rightkey="Right-key";
export function setRights(Right) {
  return Cookies.set(Rightkey, Right)
}

export function removeRights() {
  return Cookies.remove(Rightkey)
}
export function getRights() {
  return Cookies.get(Rightkey)
}

const Isremeber="Isremeber-key";
export function setIsremeber(Right) {
  return Cookies.set(Isremeber, Right)
}

export function removeIsremeber() {
  return Cookies.remove(Isremeber)
}
export function getIsremeber() {
  return Cookies.get(Isremeber)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js